import React, { useEffect, useRef, useState } from "react";
import Sidebar from "./sidebar";
import CreateModal from "./addProjectModal";
import DeleteProjectModal from "components/DeleteProjectModal/DeleteProjectModal";
import Members from "components/MembersModalPersonalArea";
import ShareModal from "components/ShareModal";
import { useDispatch, useSelector } from "react-redux";
import { getProjects } from "api/projects/getProjects";
import { setProjects, setCompanyUsers, setMilestones } from "actions/user";
import { useHttpWithCache } from "hooks/useHtthWithCache";
import { createFeatureRequest } from "api/featureRequests/createFeatureRequest";

import {
  MDBDropdown,
  MDBDropdownMenu,
  MDBDropdownToggle,
  MDBIcon,
} from "mdbreact";
import { tokenRef, url } from "api";
import axios from "axios";
import addNotification from "helpers/notify";
import EditModal from "./editProjectModal";
import TopNavbar from "./navbar";
import Loader from "components/Loader";
import { RequestCard } from "./requestCard";
import { ClockCircleOutlined, InfoCircleOutlined } from "@ant-design/icons";
import { Modal } from "antd";
import { setFeatureRequest } from "actions/user";
import BulkAssign from "components/BulkAssignModal";
import { ALL_PERMISSIONS } from "constants/permissionsConstants";
import { mainAdminGetCompanies } from "api/users/mainAdminGetCompanies";
import { mainAdminGetCompanyDetails } from "api/users/mainAdminGetCompanyDetails";

const Projects = () => {
  const dispatch = useDispatch();
  const [projects, setProjectss] = useState([]);
  const [modal, setModal] = useState("");
  const [projectToDelete, setProjectToDelete] = useState("");
  const [projectToUpdate, setProjectToUpdate] = useState(null);
  const [pageLoading, setPageLoading] = useState(false);
  const projectsRedux = useSelector((s) => s.user.projects);
  const usersRedux = useSelector((s) => s.user.users);
  const userInfoRedux = useSelector((s) => s.user.userInfo);
  const featureRequestRedux = useSelector((s) => s.user.featureRequest);
  const usersPermissionRedux = useSelector((s) => s.user.userPermission);
  const companyPermissionRedux = useSelector((s) => s.user.companyPermission);
  const allPermissionRedux = useSelector((s) => s.user.allPermission);
  const FinalPermissions = allPermissionRedux
    .filter((element) => companyPermissionRedux?.includes(element))
    ?.filter((i) => usersPermissionRedux?.includes(i));

  const [projectListToEdit, setProjectListToEdit] = useState("");

  const [selectedFile, setSelectedFile] = useState(null);
  const hiddenFileInput = useRef(null);

  const [parents, setParents] = useState([]);
  const [filteredProjects, setFilteredProjects] = useState([]);
  const [filtered, setFiltered] = useState("");
  const [projectsToAssign, setProjectsToAssign] = useState([]);

  // pagination
  // const [totalRecords, setTotalRecords] = useState();
  // const [page, setPage] = useState(0);
  // const [limit, setLimit] = useState(25);
  // const [totalPage, setTotalPage] = useState();
  //

  const handleDelete = (projectItem) => {
    setProjectToDelete(projectItem);
    setModal("DeleteModal");
  };

  const handleEdit = (projectItem) => {
    setProjectToUpdate(projectItem);
    setModal("UpdateModal");
  };

  const { loading, error, request, refresh } = useHttpWithCache({
    requestCallback: () => getProjects(),
    reduxSetter: (data) => {
      dispatch(setProjects(data.projects));
      dispatch(setCompanyUsers(data.users));
      setPageLoading(false);
    },
    reduxReset: () => {
      dispatch(setProjects(null));
      dispatch(setCompanyUsers(null));
    },
    reduxCash: {
      projects: projectsRedux,
      users: usersRedux,
    },
    allowToCash: false,
  });

  const {
    adminProjectsLoading,
    adminProjectsError,
    request: getAdminProjectsAPI,
  } = useHttpWithCache({
    // Switched from fat /admin-panel to drill-in (May-24 refactor —
    // the fat fields are empty stubs now). The configuration/projects
    // page only manages this admin's own company's projects + users.
    requestCallback: () => mainAdminGetCompanyDetails(userInfoRedux?.company),
    reduxSetter: (data) => {
      dispatch(setProjects(data?.projects || []));
      dispatch(setCompanyUsers(data?.users || []));
      setPageLoading(false);
    },
    reduxReset: () => {
      dispatch(setProjects(null));
      dispatch(setCompanyUsers(null));
    },
    reduxCash: {
      projects: projectsRedux,
      users: usersRedux,
    },
    allowToCash: false,
  });

  useEffect(() => {
    if (projectsRedux === null) {
      if (userInfoRedux?.admin) {
        getAdminProjectsAPI();
      } else {
        request();
      }
    }
  }, []);

  useEffect(() => {
    if (projectsRedux) {
      const rearrangedArray = rearrangeObjects(projectsRedux);
      setProjectss(rearrangedArray);
      let parentprojects = projectsRedux?.filter(
        (item) => item.isParent == true
      );
      if (parentprojects) setParents(parentprojects);
    }
  }, [projectsRedux]);

  const handleAccess = (projectItem) => {
    setProjectListToEdit(projectItem);
    setModal("Share");
  };
  const handleMembers = (projectItem) => {
    setProjectListToEdit(projectItem);
    setModal("ProjectListToEdit");
  };

  const handleFile = (event) => {
    setSelectedFile(event.target.files[0]);
    event.target.value = null;
  };

  const handleUploadCsv = async () => {
    // title: req.body.title,
    // description: req.body.description,
    try {
      const formData = new FormData();
      formData.append("file", selectedFile);
      // formData.append('owner', admin._id);

      // const res= await inviteUserByCsv(formData)
      const token = `Bearer ${localStorage.getItem(tokenRef)}`;
      const res = await axios.post(`${url}/projects/csv`, formData, {
        headers: {
          Authorization: token,
          "Content-Type": "multipart/form-data", // Make sure to set the content type for FormData
        },
      });
      setSelectedFile(null);
      //toggle()
      if (res?.status == 200) {
        let reduxprojects = [...res.data, ...projects];
        dispatch({
          type: "SET_PROJECTS",
          payload: reduxprojects,
        });
        addNotification("Bulk Projects Added Successfully! ", "success");
      } else {
        //toggle()
        addNotification(
          "Something went wrong, please contact support",
          "danger"
        );
      }
    } catch (error) {
      console.error("Error uploading file:", error);
    }
  };

  const handleSearch = (keyword) => {
    const filteredResult = projects.filter((project) =>
      project?.title.toLowerCase().includes(keyword.toLowerCase())
    );

    setFilteredProjects(filteredResult);

    if (keyword.length > 0) {
      setFiltered(true);
    } else {
      setFiltered(false);
    }
  };

  const [requestModal, setRequestModal] = useState(false);
  const [requestType, setRequestType] = useState("");
  const [requestLoading, setRequestLoading] = useState(false);

  const rearrangeObjects = (projects) => {
    const parent = projects.filter((x) => x.isParent);
    const children = projects.filter((x) => !x.isParent);

    for (const project of children) {
      const father = parent.find((x) => x._id == project.parentProjectID);
      if (father) {
        if (!father.child) {
          father.child = [];
        }
        father.child.push(project);
      } else {
        const father = children.find((x) => x._id === project.parentProjectID);
        if (father) {
          if (!father.child) {
            father.child = [];
          }
          father.child.push(project);
        } else {
          parent.push(project);
        }
      }
    }
    let sortedArray = [];
    parent.forEach((project) => {
      const child = project.child ? [...project.child] : [];
      delete project.child;
      const projectsArray = [project, ...child];
      sortedArray = [...sortedArray, ...projectsArray];
    });
    return sortedArray;
  };

  const requestAccess = async () => {
    try {
      setRequestLoading(true);
      const res = await createFeatureRequest(userInfoRedux.id, {
        companyId: userInfoRedux.company,
        permission: requestType,
        userId: userInfoRedux.id,
      });
      if (res) {
        setRequestLoading(false);
        dispatch(
          setFeatureRequest(res?.map((feature) => feature.requestedFeature))
        );
      }
    } catch (e) {
      setRequestLoading(false);
    }
  };

  const ProjectRow = ({ project }) => {
    return (
      <div className="d-flex justify-content-between p-2 px-3 border-bottom align-items-center">
        <p
          style={
            project?.parentProjectID
              ? { marginLeft: "40px" }
              : { marginLeft: "0px" }
          }
          className="f-14 text-black font-weight-normal mb-0"
        >
          {!project?.parentProjectID && (
            <input
              checked={projectsToAssign?.includes(project._id)}
              onChange={(e) => handleCheckBox(e, project._id)}
              type="checkbox"
              className="squared-checkbox mr-2"
            />
          )}
          {project?.title}
        </p>
        <div className="d-flex align-items-center">
          {FinalPermissions?.includes(ALL_PERMISSIONS.PROJECT_EDIT) ? (
            <span
              onClick={() => handleEdit(project)}
              className="mr-5 cursor-pointer table-icon"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="23"
                height="22"
                viewBox="0 0 23 22"
                fill="none"
              >
                <path
                  d="M5.61625 17.4999H0.3125V12.9033L14.6063 0.515428C14.8407 0.312334 15.1585 0.198242 15.49 0.198242C15.8215 0.198242 16.1393 0.312334 16.3738 0.515428L19.91 3.58018C20.1443 3.78333 20.276 4.05883 20.276 4.34609C20.276 4.63336 20.1443 4.90886 19.91 5.11201L5.61625 17.4999ZM0.3125 19.6666H22.8125V21.8333H0.3125V19.6666Z"
                  fill="#3A5765"
                />
                <path
                  d="M5.61625 17.4999H0.3125V12.9033L14.6063 0.515428C14.8407 0.312334 15.1585 0.198242 15.49 0.198242C15.8215 0.198242 16.1393 0.312334 16.3738 0.515428L19.91 3.58018C20.1443 3.78333 20.276 4.05883 20.276 4.34609C20.276 4.63336 20.1443 4.90886 19.91 5.11201L5.61625 17.4999ZM0.3125 19.6666H22.8125V21.8333H0.3125V19.6666Z"
                  fill="black"
                  fillOpacity="0.2"
                />
              </svg>
            </span>
          ) : (
            <span
              onClick={() => {
                setRequestType(ALL_PERMISSIONS.PROJECT_EDIT);
                setRequestModal(true);
              }}
              className="mr-5 cursor-pointer table-icon"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="23"
                height="22"
                viewBox="0 0 23 22"
                fill="none"
              >
                <path
                  d="M5.61625 17.4999H0.3125V12.9033L14.6063 0.515428C14.8407 0.312334 15.1585 0.198242 15.49 0.198242C15.8215 0.198242 16.1393 0.312334 16.3738 0.515428L19.91 3.58018C20.1443 3.78333 20.276 4.05883 20.276 4.34609C20.276 4.63336 20.1443 4.90886 19.91 5.11201L5.61625 17.4999ZM0.3125 19.6666H22.8125V21.8333H0.3125V19.6666Z"
                  fill="#3A5765"
                />
                <path
                  d="M5.61625 17.4999H0.3125V12.9033L14.6063 0.515428C14.8407 0.312334 15.1585 0.198242 15.49 0.198242C15.8215 0.198242 16.1393 0.312334 16.3738 0.515428L19.91 3.58018C20.1443 3.78333 20.276 4.05883 20.276 4.34609C20.276 4.63336 20.1443 4.90886 19.91 5.11201L5.61625 17.4999ZM0.3125 19.6666H22.8125V21.8333H0.3125V19.6666Z"
                  fill="black"
                  fillOpacity="0.2"
                />
              </svg>
            </span>
          )}

          {FinalPermissions?.includes(ALL_PERMISSIONS.PROJECT_DELETE) ? (
            <span
              onClick={() => handleDelete(project)}
              className="mr-5 ml-2 cursor-pointer table-icon"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="26"
                height="22"
                viewBox="0 0 26 22"
                fill="none"
              >
                <path
                  d="M19.4375 2.33317H25.6875V4.49984H23.1875V20.7498C23.1875 21.0372 23.0558 21.3127 22.8214 21.5159C22.587 21.719 22.269 21.8332 21.9375 21.8332H4.4375C4.10598 21.8332 3.78804 21.719 3.55362 21.5159C3.3192 21.3127 3.1875 21.0372 3.1875 20.7498V4.49984H0.6875V2.33317H6.9375V0.166504H19.4375V2.33317ZM9.4375 7.74984V16.4165H11.9375V7.74984H9.4375ZM14.4375 7.74984V16.4165H16.9375V7.74984H14.4375Z"
                  fill="#3A5765"
                />
                <path
                  d="M19.4375 2.33317H25.6875V4.49984H23.1875V20.7498C23.1875 21.0372 23.0558 21.3127 22.8214 21.5159C22.587 21.719 22.269 21.8332 21.9375 21.8332H4.4375C4.10598 21.8332 3.78804 21.719 3.55362 21.5159C3.3192 21.3127 3.1875 21.0372 3.1875 20.7498V4.49984H0.6875V2.33317H6.9375V0.166504H19.4375V2.33317ZM9.4375 7.74984V16.4165H11.9375V7.74984H9.4375ZM14.4375 7.74984V16.4165H16.9375V7.74984H14.4375Z"
                  fill="black"
                  fillOpacity="0.2"
                />
              </svg>
            </span>
          ) : (
            <span
              onClick={() => {
                setRequestType(ALL_PERMISSIONS.PROJECT_DELETE);
                setRequestModal(true);
              }}
              className="mr-5 cursor-pointer"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="26"
                height="22"
                viewBox="0 0 26 22"
                fill="none"
              >
                <path
                  d="M19.4375 2.33317H25.6875V4.49984H23.1875V20.7498C23.1875 21.0372 23.0558 21.3127 22.8214 21.5159C22.587 21.719 22.269 21.8332 21.9375 21.8332H4.4375C4.10598 21.8332 3.78804 21.719 3.55362 21.5159C3.3192 21.3127 3.1875 21.0372 3.1875 20.7498V4.49984H0.6875V2.33317H6.9375V0.166504H19.4375V2.33317ZM9.4375 7.74984V16.4165H11.9375V7.74984H9.4375ZM14.4375 7.74984V16.4165H16.9375V7.74984H14.4375Z"
                  fill="#3A5765"
                />
                <path
                  d="M19.4375 2.33317H25.6875V4.49984H23.1875V20.7498C23.1875 21.0372 23.0558 21.3127 22.8214 21.5159C22.587 21.719 22.269 21.8332 21.9375 21.8332H4.4375C4.10598 21.8332 3.78804 21.719 3.55362 21.5159C3.3192 21.3127 3.1875 21.0372 3.1875 20.7498V4.49984H0.6875V2.33317H6.9375V0.166504H19.4375V2.33317ZM9.4375 7.74984V16.4165H11.9375V7.74984H9.4375ZM14.4375 7.74984V16.4165H16.9375V7.74984H14.4375Z"
                  fill="black"
                  fillOpacity="0.2"
                />
              </svg>
            </span>
          )}

          <MDBDropdown>
            <MDBDropdownToggle style={{ padding: 0 }} color="link">
              <span className="cursor-pointer table-icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="5"
                  height="20"
                  viewBox="0 0 5 20"
                  fill="none"
                >
                  <path
                    d="M2.73694 19.0519C2.43894 19.0563 2.14322 18.9996 1.86801 18.8853C1.59281 18.7709 1.34397 18.6013 1.13693 18.3869C0.922562 18.1799 0.752962 17.931 0.638581 17.6558C0.524199 17.3806 0.467459 17.0849 0.471924 16.7869C0.467459 16.4889 0.524199 16.1932 0.638581 15.918C0.752962 15.6428 0.922562 15.3939 1.13693 15.1869C1.34397 14.9725 1.59281 14.8029 1.86801 14.6885C2.14322 14.5742 2.43894 14.5174 2.73694 14.5219C3.03493 14.5174 3.33066 14.5742 3.60587 14.6885C3.88107 14.8029 4.1299 14.9725 4.33695 15.1869C4.55132 15.3939 4.72092 15.6428 4.8353 15.918C4.94968 16.1932 5.00642 16.4889 5.00195 16.7869C5.00642 17.0849 4.94968 17.3806 4.8353 17.6558C4.72092 17.931 4.55132 18.1799 4.33695 18.3869C4.1299 18.6013 3.88107 18.7709 3.60587 18.8853C3.33066 18.9996 3.03493 19.0563 2.73694 19.0519ZM2.73694 12.2619C2.43894 12.2664 2.14322 12.2097 1.86801 12.0953C1.59281 11.9809 1.34397 11.8113 1.13693 11.5969C0.922562 11.3899 0.752962 11.141 0.638581 10.8658C0.524199 10.5906 0.467459 10.2949 0.471924 9.99689C0.467459 9.69889 0.524199 9.40313 0.638581 9.12793C0.752962 8.85273 0.922562 8.60395 1.13693 8.39691C1.34397 8.18254 1.59281 8.01288 1.86801 7.8985C2.14322 7.78412 2.43894 7.72741 2.73694 7.73187C3.03493 7.72741 3.33066 7.78412 3.60587 7.8985C3.88107 8.01288 4.1299 8.18254 4.33695 8.39691C4.55132 8.60395 4.72092 8.85273 4.8353 9.12793C4.94968 9.40313 5.00642 9.69889 5.00195 9.99689C5.00642 10.2949 4.94968 10.5906 4.8353 10.8658C4.72092 11.141 4.55132 11.3899 4.33695 11.5969C4.12999 11.8115 3.8812 11.9813 3.60599 12.0958C3.33078 12.2104 3.03501 12.2662 2.73694 12.2619ZM2.73694 5.47192C2.43894 5.47639 2.14322 5.41968 1.86801 5.3053C1.59281 5.19092 1.34397 5.02126 1.13693 4.80689C0.922562 4.59984 0.752962 4.35107 0.638581 4.07587C0.524199 3.80066 0.467459 3.5049 0.471924 3.20691C0.467459 2.90892 0.524199 2.61316 0.638581 2.33795C0.752962 2.06275 0.922562 1.81391 1.13693 1.60687C1.34397 1.3925 1.59281 1.2229 1.86801 1.10852C2.14322 0.994139 2.43894 0.937429 2.73694 0.941895C3.03493 0.937429 3.33066 0.994139 3.60587 1.10852C3.88107 1.2229 4.1299 1.3925 4.33695 1.60687C4.55132 1.81391 4.72092 2.06275 4.8353 2.33795C4.94968 2.61316 5.00642 2.90892 5.00195 3.20691C5.00642 3.5049 4.94968 3.80066 4.8353 4.07587C4.72092 4.35107 4.55132 4.59984 4.33695 4.80689C4.12999 5.02144 3.8812 5.19123 3.60599 5.30579C3.33078 5.42034 3.03501 5.47626 2.73694 5.47192Z"
                    fill="#455E6C"
                  />
                </svg>
              </span>
            </MDBDropdownToggle>
            <MDBDropdownMenu responsive="lg-end" style={{ width: "150px" }}>
              <div className="card">
                <div className="card-body px-2">
                  <div
                    onClick={() => {
                      FinalPermissions?.includes(
                        ALL_PERMISSIONS.SHARE_PROJECT_ADD
                      )
                        ? handleAccess(project)
                        : setRequestModal(true);
                      setRequestType(ALL_PERMISSIONS.SHARE_PROJECT_ADD);
                    }}
                    style={{
                      color: "white",
                      backgroundColor: "#3A5765",
                      marginBottom: "5px",
                      textAlign: "center",
                      cursor: "pointer",
                    }}
                    className="rounded p-1"
                  >
                    {" "}
                    Access{" "}
                  </div>
                  <div
                    onClick={() => {
                      FinalPermissions?.includes(
                        ALL_PERMISSIONS.ASSIGN_PROJECT_ADD
                      )
                        ? handleMembers(project)
                        : setRequestModal(true);
                      setRequestType(ALL_PERMISSIONS.ASSIGN_PROJECT_ADD);
                    }}
                    style={{
                      color: "white",
                      backgroundColor: "#3A5765",
                      marginBottom: "5px",
                      textAlign: "center",
                      cursor: "pointer",
                    }}
                    className="rounded p-1"
                  >
                    {" "}
                    Members{" "}
                  </div>
                  {/* <div onClick={handleHistory} style={{ color: "white", backgroundColor: "#3A5765", marginBottom: "5px", textAlign: "center", cursor: "pointer" }} className="rounded p-1"> History </div> */}
                </div>
              </div>
            </MDBDropdownMenu>
          </MDBDropdown>
        </div>
      </div>
    );
  };

  const handleCheckBox = (e, id) => {
    const isChecked = e.target.checked;

    const index = projectsToAssign.indexOf(id);

    if (isChecked && index === -1) {
      setProjectsToAssign((prev) => [...prev, id]);
    }

    if (!isChecked && index !== -1) {
      setProjectsToAssign((prev) => prev.filter((userId) => userId !== id));
    }
  };

  // var pageData = {
  //   index: page,
  //   limit: limit,
  // };

  // useEffect(() => {
  // }, [page, limit]);

  return (
    <>
      {pageLoading && <Loader />}
      <div className="personal-area">
        <TopNavbar handleSearch={handleSearch} />

        <div className="content-bg p-2">
          <div className="container d-flex mt-1">
            <Sidebar />

            <div className="profile-content px-0 pt-0">
              <div className="w-100 px-0">
                <div className="d-flex justify-content-between px-3 py-3 border-bottom">
                  <div className="d-flex align-items-center text-black">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      className="bi bi-bag-fill"
                      viewBox="0 0 16 16"
                    >
                      <path d="M8 1a2.5 2.5 0 0 1 2.5 2.5V4h-5v-.5A2.5 2.5 0 0 1 8 1m3.5 3v-.5a3.5 3.5 0 1 0-7 0V4H1v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V4z" />
                    </svg>
                    <span className="font-weight-bold ml-3 f-14">
                      Projects Settings
                    </span>
                  </div>
                  <div className="d-flex">
                    {selectedFile ? (
                      <div
                        onClick={handleUploadCsv}
                        className="header-btn bg-white text-bid border-bid rounded-lg mr-0 mb-0 cursor-pointer f-14 roboto font-weight-normal"
                      >
                        Upload
                      </div>
                    ) : usersPermissionRedux?.includes("projectAdd") ? (
                      <div
                        onClick={() => setModal("CreateModal")}
                        data-toggle="modal"
                        data-target="#exampleModalCenter"
                        className="header-btn bg-white text-bid border-bid rounded-lg mr-0 mb-0 cursor-pointer f-14 roboto font-weight-normal"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="13"
                          height="13"
                          viewBox="0 0 13 13"
                          fill="none"
                        >
                          <path
                            d="M5.60013 9.11418H6.61313V6.62315H9.11313V5.61015H6.61313V3.03819H5.60013V5.61015H3.03813V6.62315H5.60013V9.11418ZM6.07913 12.1521C5.26654 12.1572 4.46167 11.9941 3.71513 11.6731C2.99435 11.3666 2.33864 10.9254 1.78313 10.3732C1.23087 9.81769 0.78965 9.16196 0.483133 8.44114C0.160192 7.69298 -0.00426501 6.88603 0.000131185 6.07115C-0.00529131 5.25797 0.157444 4.45248 0.478128 3.70518C0.783938 2.98546 1.22529 2.33125 1.77813 1.77818C2.33424 1.22671 2.9898 0.785612 3.71013 0.478193C4.45897 0.156833 5.26627 -0.00594709 6.08113 0.000166009C6.89431 -0.00525648 7.69983 0.157509 8.44713 0.478193C9.16637 0.784898 9.82042 1.22612 10.3741 1.77818C10.9265 2.33241 11.3678 2.98713 11.6741 3.70714C11.9947 4.45482 12.1574 5.26065 12.1521 6.07414C12.1575 6.88667 11.9948 7.69154 11.6741 8.43815C11.3669 9.15798 10.9257 9.81291 10.3741 10.3681C9.81993 10.9206 9.16516 11.3619 8.44513 11.6682C7.69798 11.991 6.89203 12.1554 6.07813 12.1512L6.07913 12.1521Z"
                            fill="#455E6C"
                          />
                        </svg>{" "}
                        <span className="ml-2 font-weight-normal">
                          Add Projects
                        </span>
                      </div>
                    ) : (
                      <div
                        onClick={() => {
                          setRequestType("projectAdd");
                          setRequestModal(true);
                        }}
                        data-toggle="modal"
                        data-target="#exampleModalCenter"
                        className="header-btn bg-white text-bid border-bid rounded-lg mr-0 mb-0 cursor-pointer f-14 roboto font-weight-normal"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="13"
                          height="13"
                          viewBox="0 0 13 13"
                          fill="none"
                        >
                          <path
                            d="M5.60013 9.11418H6.61313V6.62315H9.11313V5.61015H6.61313V3.03819H5.60013V5.61015H3.03813V6.62315H5.60013V9.11418ZM6.07913 12.1521C5.26654 12.1572 4.46167 11.9941 3.71513 11.6731C2.99435 11.3666 2.33864 10.9254 1.78313 10.3732C1.23087 9.81769 0.78965 9.16196 0.483133 8.44114C0.160192 7.69298 -0.00426501 6.88603 0.000131185 6.07115C-0.00529131 5.25797 0.157444 4.45248 0.478128 3.70518C0.783938 2.98546 1.22529 2.33125 1.77813 1.77818C2.33424 1.22671 2.9898 0.785612 3.71013 0.478193C4.45897 0.156833 5.26627 -0.00594709 6.08113 0.000166009C6.89431 -0.00525648 7.69983 0.157509 8.44713 0.478193C9.16637 0.784898 9.82042 1.22612 10.3741 1.77818C10.9265 2.33241 11.3678 2.98713 11.6741 3.70714C11.9947 4.45482 12.1574 5.26065 12.1521 6.07414C12.1575 6.88667 11.9948 7.69154 11.6741 8.43815C11.3669 9.15798 10.9257 9.81291 10.3741 10.3681C9.81993 10.9206 9.16516 11.3619 8.44513 11.6682C7.69798 11.991 6.89203 12.1554 6.07813 12.1512L6.07913 12.1521Z"
                            fill="#455E6C"
                          />
                        </svg>{" "}
                        <span className="ml-2">Add Projects</span>
                      </div>
                    )}

                    {projectsToAssign.length > 0 && (
                      <div
                        onClick={() => setModal("BulkAssign")}
                        className="header-btn bg-white text-bid border-bid rounded-lg mr-0 ml-2 mb-0 cursor-pointer f-14 roboto font-weight-normal"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="13"
                          height="13"
                          viewBox="0 0 13 13"
                          fill="none"
                        >
                          <path
                            d="M5.60013 9.11418H6.61313V6.62315H9.11313V5.61015H6.61313V3.03819H5.60013V5.61015H3.03813V6.62315H5.60013V9.11418ZM6.07913 12.1521C5.26654 12.1572 4.46167 11.9941 3.71513 11.6731C2.99435 11.3666 2.33864 10.9254 1.78313 10.3732C1.23087 9.81769 0.78965 9.16196 0.483133 8.44114C0.160192 7.69298 -0.00426501 6.88603 0.000131185 6.07115C-0.00529131 5.25797 0.157444 4.45248 0.478128 3.70518C0.783938 2.98546 1.22529 2.33125 1.77813 1.77818C2.33424 1.22671 2.9898 0.785612 3.71013 0.478193C4.45897 0.156833 5.26627 -0.00594709 6.08113 0.000166009C6.89431 -0.00525648 7.69983 0.157509 8.44713 0.478193C9.16637 0.784898 9.82042 1.22612 10.3741 1.77818C10.9265 2.33241 11.3678 2.98713 11.6741 3.70714C11.9947 4.45482 12.1574 5.26065 12.1521 6.07414C12.1575 6.88667 11.9948 7.69154 11.6741 8.43815C11.3669 9.15798 10.9257 9.81291 10.3741 10.3681C9.81993 10.9206 9.16516 11.3619 8.44513 11.6682C7.69798 11.991 6.89203 12.1554 6.07813 12.1512L6.07913 12.1521Z"
                            fill="#455E6C"
                          />
                        </svg>{" "}
                        <span className="ml-2">Bulk Assign</span>
                      </div>
                    )}
                  </div>
                </div>

                <div className="border-bottom p-2 px-3 f-12 font-weight-normal bg-table-header">
                  Project Name
                </div>

                {filtered ? (
                  <>
                    {" "}
                    {filteredProjects?.map((project, i) => (
                      <ProjectRow key={i} project={project} />
                    ))}
                    {filteredProjects.length === 0 && (
                      <p className="m-3">There is no projects</p>
                    )}
                  </>
                ) : (
                  <>
                    {projects?.map((project, i) => (
                      <ProjectRow key={i} project={project} />
                    ))}
                    {projects.length === 0 && (
                      <p className="m-3">There is no projects</p>
                    )}
                  </>
                )}

                {/* <Pagination
                  totalRecords={projects.length}
                  totalPage={Math.ceil(projects.length / limit)}
                  recordsPerPage={10}
                  page={page + 1}
                  onPageChange={(pageNo) => setPage(pageNo - 1)}
                  limit={limit}
                  onLimitChange={(limitNo) => {
                    setLimit(limitNo);
                  }}
                /> */}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* modals */}
      <CreateModal
        parents={parents}
        isOpen={modal === "CreateModal"}
        toggle={() => setModal("")}
      />

      {modal === "UpdateModal" && (
        <EditModal
          projectToUpdate={projectToUpdate}
          // projects={projects}
          isOpen={modal === "UpdateModal"}
          toggle={() => setModal("")}
        />
      )}

      <DeleteProjectModal
        isOpen={modal === "DeleteModal"}
        toggle={() => setModal("")}
        itemToDelete={projectToDelete ? { _id: projectToDelete._id } : null}
      />

      <Members
        open={modal === "ProjectListToEdit"}
        toggle={() => setModal("")}
        projectListToEdit={projectListToEdit ? projectListToEdit._id : null}
      />

      <ShareModal
        open={modal === "Share"}
        toggle={() => setModal("")}
        projectItem={projectListToEdit}
        setProjectItem={setProjectListToEdit}
      />

      <BulkAssign
        open={modal === "BulkAssign"}
        toggle={() => setModal("")}
        projectsToAssign={projectsToAssign}
      />

      <input
        style={{ display: "none" }}
        type="file"
        accept=".csv"
        name="file_image"
        className="file-input"
        id="input_image"
        required
        ref={hiddenFileInput}
        onChange={handleFile}
      />
      <Modal
        title={
          userInfoRedux?.companyAdmin ? "Acquire License" : "Request Access"
        }
        open={requestModal}
        footer={null}
        onCancel={() => setRequestModal(false)}
      >
        <RequestCard
          status={featureRequestRedux?.includes(requestType)}
          loading={requestLoading}
          icon={
            featureRequestRedux?.includes(requestType) ? (
              <ClockCircleOutlined style={{ color: "black" }} />
            ) : (
              <InfoCircleOutlined style={{ color: "black" }} />
            )
          }
          title={
            featureRequestRedux?.includes(requestType)
              ? `Request Already Sent`
              : `Oops, looks like you need to ${
                  userInfoRedux?.companyAdmin
                    ? `Acquire License`
                    : `Request Access`
                }`
          }
          description={
            featureRequestRedux?.includes(requestType)
              ? `Please reach out to your project Admin`
              : `Elevate your experience with exclusive futures, early releases, and premium features.`
          }
          buttonText={
            userInfoRedux?.companyAdmin ? "Acquire License" : "Request Access"
          }
          buttonHandler={() => requestAccess()}
        />
      </Modal>
    </>
  );
};

export default Projects;
